"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 1C7.19 1 3.7 3.39 2.41 5.92c-.25.49.12 1.08.68 1.08.28 0 .54-.15.66-.4.98-1.91 3.83-4.1 8.25-4.1 3.03 0 5.79 1.14 7.91 3h-2.16c-.41 0-.75.34-.75.75s.34.75.75.75H21c.55 0 1-.45 1-1V2.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.27C18.18 2.13 15.22 1 12 1M5.2 17.43c0-.65.6-1.13 1.24-.99l3.56.8V6.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v6h.91c.31 0 .62.07.89.21l4.09 2.04c.77.38 1.21 1.22 1.09 2.07l-.63 4.46c-.14.99-.99 1.72-1.98 1.72h-6.16c-.53 0-1.29-.21-1.66-.59l-4.07-4.29c-.18-.18-.28-.43-.28-.69"
}), 'SwipeRightRounded');